import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { SdVoteId } from '../../../../../shared/constants/sd-ballot.constants';
import { ToastService } from '../../../../../shared/services/toast.service';
import { ISdVoteDto, ISubmitSdBallotVoteRequest } from '../../../shared/models/sd/sd-vote';
import { SdBallotService } from '../../../shared/services/sd-ballot.service';
import { noWhitespaceValidator } from '../../../shared/validator/noWhitespaceValidator';

@Component({
  selector: 'app-sd-non-eligible-comment-modal',
  standalone: false,
  templateUrl: './sd-non-eligible-comment-modal.component.html',
  styleUrl: './sd-non-eligible-comment-modal.component.scss',
})
export class SdNonEligibleCommentModalComponent {
  @Input() userVote!: ISdVoteDto;
  subscriptions: Subscription = new Subscription();
  comment = '';

  userCommentForm = new FormGroup({
    userComment: new FormControl<string | null>(null, [
      noWhitespaceValidator
    ]),
  });


  constructor(private activeModal: NgbActiveModal, private _sdBallotService: SdBallotService, private _toastService: ToastService) {}

  @Output() close = new EventEmitter<void>();
  @Output() submitComment = new EventEmitter<string>();


  cancel() {
    this.activeModal.dismiss('cancel');
  }

  onSubmit() {
    const comment = this.userCommentForm.controls.userComment.value;
    if (!comment?.trim()) return;
    let vote: ISubmitSdBallotVoteRequest = this.getUserVote(comment);
    this.subscriptions.add(
    this._sdBallotService.placeVote(vote).subscribe({
      next: () => {
        this._toastService.showSuccess("Your Comment has been submitted. Thank You!", "Comment Successful");
        debugger;
        this.activeModal.dismiss(vote);
      },
      error: (err) => {
        console.error(err);
        this._toastService.showError("if there is a network issue or similar which is existing. Please let me know if you need anything else.");
        this.activeModal.dismiss('cancel');
      }
    })
  );

  }

  getUserVote(comment: string) : ISubmitSdBallotVoteRequest {

    return  {
      ballotId: this.userVote?.ballotRecordId,
      voteResult:  SdVoteId.VT_NONE,
      ballotVoteId : this.userVote?.ballotVoteId,
      ballotComment: comment,
      isCOA: false
    }

  }
}
